export default {
	name: 'customerQuery',
	data() {
		return {
			search: '',
			beginData: '',
			endTime: '',
			clear: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			getData: {},
			customers: [],
			ShopID: this.$store.state.user.ShopID,
			areaID: this.$store.state.user.areaID,

			Shop: this.$store.state.shop.filter(x => x.areaID == this.areaID)
		}
	},
	created() {
		this.areaID = this.$store.state.user.areaID;
		this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
		this.getData = () => {

			this.$request.request({
				url: 'Query/queryCustomer',
				data: {
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					beginData: this.beginData,
					endTime: this.endTime,
					searchText: this.search,
					ShopID: this.ShopID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.search = r.searchText,
						this.customers = r.customers;
					this.count = r.count;
				} else {
					this.$uil.showMessage({
						text: r.message
					});
				}
			})
		}
		this.getData();

	},

	methods: {
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			if (this.Shop.length > 0) {
				this.ShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkbook() {
			return this.BooksName.length > 0 && this.BookBriefIntroduction.length > 0 && this.WriterName.length > 0 &&
				this.ClassificationID >
				0 && this.RecommendReason.length > 0 && this.BookRecommend.length > 0 && this.Tag.length > 0;
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {

	}
}
